module.exports = __webpack_public_path__ + "media/images/clarity-b58a9503.svg";